// removed by extract-text-webpack-plugin
module.exports = {"cwShellTopNav":"CwShellTopNav-cwShellTopNav"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshelltopnav/CwShellTopNav.scss
// module id = 389
// module chunks = 0